$(function () {
  $('.interview-link, .event-link, .js-general-user').on('click', function(e){
    //伝播をストップ
    e.stopPropagation();
    e.preventDefault();

    //リンクを取得して飛ばす
    location.href = $(this).attr('data-href');
  });
});
